<template>
  <page-list
    ref="EXTERNAL"
    v-if="settingLoaded"
    :list="list"
    :columns="columns"
    :single-actions="singleActions"
    :export-data-options="exportDataOptions"
    :group-actions="groupActions"
    :editConfig="{trigger: 'click', mode: 'cell', showIcon: false, showStatus: true}"
    :dataMapper="listDataMapper" />
    <!-- <template v-slot:group-actions-prepend>
      <div class="d-flex ml-2">
        <a-button class="ml-2" type="primary" @click="goReportSubscriptionCreate">{{$t('report.action.subscription')}}</a-button>
        <a-button class="ml-2" type="link" @click="showHistoryList">{{$t('report.history_report')}}</a-button>
      </div>
    </template>
  </page-list> -->
</template>

<script>
import * as R from 'ramda'
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'
import { getTimeTableColumn, getProjectDomainTableColumn, getNameDescriptionTableColumn } from '@/utils/common/tableColumn'
import { getNameFilter } from '@/utils/common/tableFilter'

export default {
  name: 'ReportDataList',
  mixins: [WindowsMixin, ListMixin],
  props: {
    getParams: {
      type: Object,
      default: () => ({}),
    },
    resId: String,
    listId: String,
    // report_setting_id: String,
    title: String,
  },
  data () {
    return {
      reportLoading: false,
      columns: [],
      settingLoaded: false,
      reportSetting: {},
      list: this.$list.createList(this, {
        id: this.listId + '_' + this.resId,
        resource: 'reports',
        apiVersion: 'v1',
        getParams: this.getParam,
        filterOptions: {
          name: getNameFilter(),
        },
      }),
      groupActions: [],
      timeOpts: [
        { key: 'week', label: this.$t('common.date_time.week') },
        { key: 'last_week', label: this.$t('common.date_time.last_week') },
        { key: 'month', label: this.$t('common.date_time.month') },
        { key: 'last_month', label: this.$t('common.date_time.last_month') },
        { key: 'year', label: this.$t('common.date_time.year') },
      ],
      exportDataItems: [],
      multipleChangeEnable: false,
      editDatas: {},
      historyTimeList: [],
      currentHistoryTime: '',
    }
  },
  computed: {
    exportDataOptions () {
      return {
        downloadType: 'local',
        exportTitle: this.title,
        items: this.exportDataItems,
        extraExportParams: {
          filter: [
            `report_setting_id.equals(${this.resId})`,
          ],
        },
        transformParams: (params) => {
          if (!params.filter) {
            params.filter = [`report_setting_id.equals(${this.resId})`]
          }
          return params
        },
      }
    },
  },
  watch: {
    currentHistoryTime: {
      handler: function (val) {
        if (val) {
          this.list.reset(true)
          this.list.fetchData()
        }
      },
    },
    resId: {
      handler: function () {
        this.list.reset(true)
        this.currentHistoryTime = ''
        this.initSettingConfig()
        this.initHistoryList()
      },
    },
  },
  created () {
    this.$sM = new this.$Manager('report_settings', 'v1')
    this.$rM = new this.$Manager('reports', 'v1')
    this.initSettingConfig()
    this.initHistoryList()
  },
  methods: {
    showHistoryList () {
      this.createDialog('ReportHistoryDialog', {
        historyTimeList: this.historyTimeList,
        currentHistoryTime: this.currentHistoryTime,
        reportSetting: this.reportSetting,
        selectTime: this.selectTime,
      })
    },
    selectTime (timeItem) {
      this.currentHistoryTime = timeItem.id
    },
    dateFormatter (time) {
      return this.$moment(time).format('YYYY-MM-DD HH:mm:ss')
    },
    listDataMapper (data, extraData) {
      for (const k in data) {
        if (data[k].data && data[k].data.values) {
          for (const j in data[k].data.values) {
            data[k].data[j] = data[k].data.values[j]
          }
        }
      }
      return data
    },
    async initHistoryList () {
      const utc = 0 - new Date().getTimezoneOffset() / 60
      const { data } = await this.$rM.get({
        id: 'distinct-field',
        params: {
          scope: this.$store.getters.scope,
          field: 'created_at',
          filter: [
            `report_setting_id.equals(${this.resId})`,
          ],
        },
      })
      const { created_at = [] } = data
      const list = created_at.reverse()
      const ret = []
      list.map(item => {
        const label = this.$moment(item).add(utc, 'hours').format('YYYY-MM-DD HH:mm')
        const start = this.$moment(item).format('YYYY-MM-DD HH:mm') + ':00'
        const end = this.$moment(item).add(1, 'minutes').format('YYYY-MM-DD HH:mm') + ':00'
        const timeItem = { id: start, label, start, end }
        const target = ret.filter(item => item.id === start)
        if (!target.length) {
          ret.push(timeItem)
        }
      })
      ret.sort((a, b) => new Date(b.id).getTime() - new Date(a.id).getTime())
      this.historyTimeList = ret
      this.currentHistoryTime = this.historyTimeList[0] ? this.historyTimeList[0].id : ''
    },
    async initSettingConfig () {
      try {
        const { data = {} } = await this.$sM.get({
          id: this.resId,
          params: {
            scope: this.$store.getters.scope,
          },
        })
        this.reportSetting = data
        const { elements = [] } = data
        const columns = [
          getNameDescriptionTableColumn({
            onManager: this.onManager,
            hideField: true,
            edit: false,
            editDesc: false,
            slotCallback: row => {
              return (<side-page-trigger onTrigger={ () => this.handleOpenSidepage(row) }>{ row.name }</side-page-trigger>)
            },
          }),
          getTimeTableColumn({ title: this.$t('report.report_create_time') }),
          getProjectDomainTableColumn(),
        ]
        const exportItems = [
          getNameDescriptionTableColumn({
            onManager: this.onManager,
            hideField: true,
            edit: false,
            editDesc: false,
            slotCallback: row => {
              return (<side-page-trigger onTrigger={ () => this.handleOpenSidepage(row) }>{ row.name }</side-page-trigger>)
            },
          }),
          {
            ...getTimeTableColumn({ title: this.$t('report.report_create_time') }),
            formatter: ({ row }) => {
              if (row.created_at) {
                return this.$moment(row.created_at).format()
              }
              return ''
            },
          },
          getProjectDomainTableColumn(),
        ]
        elements.map(item => {
          columns.push({
            field: item.name,
            title: item.name,
            slots: {
              default: ({ row }) => {
                return (row.values && row.values[item.name]) || this.reportDefaultValue(item.name)
              },
            },
          })
          exportItems.push({
            key: item.name,
            label: item.name,
            formatter: ({ row }) => {
              return row.values && row.values[item.name]
            },
          })
        })
        this.columns = columns
        this.exportDataItems = exportItems
        this.settingLoaded = true
      } catch (err) { throw err }
    },
    refresh () {
      this.list.fetchData()
    },
    getParam () {
      const ret = {
        scope: this.$store.getters.scope,
        ...(R.is(Function, this.getParams) ? this.getParams() : this.getParams),
        details: true,
        filter: [
          `report_setting_id.equals(${this.resId})`,
        ],
      }
      const target = this.historyTimeList.filter(item => item.id === this.currentHistoryTime)
      if (target[0]) {
        ret.filter.push(`created_at.between("${target[0].start}", "${target[0].end}")`)
      }
      return ret
    },
    reportDefaultValue (name) {
      return 0
    },
    goReportSubscriptionCreate () {
      const report_setting_id = this.resId
      let name = 'ReportDomainSubscriptionCreate'

      switch (report_setting_id) {
        case 'default_domain_report':
          name = 'ReportDomainSubscriptionCreate'
          break
        case 'default_project_report':
          name = 'ReportProjectSubscriptionCreate'
          break
        default:
          name = 'ReportCustomSubscriptionCreate'
          break
      }

      this.$router.push({
        name,
        query: {
          report_setting_id: this.resId,
        },
      })
    },
    handleOpenSidepage (row) {
      // this.initSidePageTab('report-list')
      this.sidePageTriggerHandle(this, 'ReportDataSidePage', {
        id: row.id,
        resource: () => { return { data: row } },
        columns: this.columns,
        exportDataOptions: this.exportDataOptions,
        title: this.title,
      }, {
        list: this.list,
      })
    },
  },
}
</script>
